import { useEffect, useState } from "react";
import { api } from "./api";

// Module-level cache so we hit /api/countries once per session, not per component.
let CACHE = null;
let CACHE_PROMISE = null;

function loadAll() {
  if (CACHE) return Promise.resolve(CACHE);
  if (!CACHE_PROMISE) {
    // Swallow any network/permission error: callers fall back to []
    // rather than triggering the React dev-overlay on /start.
    CACHE_PROMISE = api.get("/countries")
      .then(r => (CACHE = r.data))
      .catch(() => (CACHE = []));
  }
  return CACHE_PROMISE;
}

/** Returns the full ISO country list (cached). */
export function useCountries() {
  const [countries, setCountries] = useState(CACHE || []);
  useEffect(() => { loadAll().then(setCountries); }, []);
  return countries;
}

/**
 * Returns ONLY the countries the current company operates in (if set), else
 * falls back to the full ISO list. Components that pick countries for an
 * employee (Employees page) or filter bank holidays (BankHolidays page)
 * should use this so the dropdown is scoped per the company's settings.
 */
export function useCompanyCountries(company) {
  const all = useCountries();
  if (!company || !company.countries?.length) return all;
  const allowed = new Set(company.countries);
  return all.filter(c => allowed.has(c.code));
}

// Same list, sync - returns [] until /api/countries has resolved at least once.
export function getCountriesSync() { return CACHE || []; }
